module.exports = __webpack_public_path__ + "src/img/scan.1ceb241d.svg";